"use strict";

angular.module("core").component("fileUpload", {
    templateUrl: require("./file-upload.component.html"),
    controllerAs: "fileUploadCtrl",
    bindings: {
        name: "@",
        form: "=",
        accept: "@",
        fileTypesAllowed: "@",
        maxFileSize: "<",
        helpText: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/file-upload/file-upload.component.js
// module id = 571
// module chunks = 0